exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-check-input-box{\n  border: 1px solid #e9ecef;\n  position: relative; \n  height: 1.25em;\n  background-image: linear-gradient(310deg,#7928ca,#ff0080) !important; \n}\n\na:hover {\n  color: unset; \n}", ""]);

// exports
